export const HEADER_MENU = 'header-menu';
export const PRICES = 'prices';
export const MAP = 'map';
export const FILTERS = 'filters';
export const SORT_BY = 'sort';
